export default __webpack_public_path__ + "static/media/superman.d2d45aaf.png";